export const CGP_STATE_POPUP_LOCAL_STORAGE_KEY = 'cgp_state-popup';